<template>
  <div class="asc-derived-parameter-input">
    <div class="parameterNameWrapper">
      <v-row no-gutters>
        <v-col>
          <div
            class="labelFieldInput"
            :style="{
              'min-width': '400px',
            }"
          >
            <asc-text-field-input
              :value="parameterName"
              label="Parameter Name"
              :max-length="500"
              :error="true"
              @blur="handleBlurParameterName"
              @change="handleChangeParameterName"
              @keypress.native="handleSpecialCharacters"
              @paste.native.prevent
            />
          </div>
        </v-col>
        <v-col v-if="!isSingleAirlineUserCheck">
          <div class="labelFieldInput">
            <asc-text-field-input
              v-model="airlineName"
              label="Airline"
              :max-length="100"
              readonly
              :no-spacing="false"
            />
          </div>
        </v-col>
        <v-col>
          <asc-text-field-input
            v-model="platformText"
            label="Platform"
            :max-length="100"
            readonly
            :no-spacing="false"
          />
        </v-col>
        <v-col>
          <asc-text-field-input
            v-model="parameterTypeName"
            label="Data Type"
            :max-length="100"
            readonly
            hide-details
            :no-spacing="false"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
export default {
  name: 'AscDerivedParameterInputWrapper',

  components: {
    AscTextFieldInput,
  },

  props: {
    airlineName: {
      type: String,
      default: '',
    },
    alertType: {
      type: String,
      required: true,
    },
    parameterTypeName: {
      type: String,
      default: 'Full Flight',
    },
    airlineId: {
      type: Number,
      default: null,
    },
    parameterName: {
      type: String,
      default: '',
    },
    platformText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {}
  },

  computed: {
    isSingleAirlineUserCheck() {
      return this.$route.query.isSingleAirlineUser === 'true' ? true : false
    },
  },
  watch: {},

  methods: {
    handleBlurParameterName(parameterName) {
      this.$emit('handleBlurParameterName', parameterName)
    },
    handleChangeParameterName(parameterName) {
      this.$emit('handleChangeParameterName', parameterName)
    },
    handleSpecialCharacters(e) {
      const keyCode = e.keyCode
      if (
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 65 && keyCode <= 90) ||
        (keyCode >= 97 && keyCode <= 122) ||
        keyCode == 95 || // for underscore
        keyCode == 32 // for space
      ) {
        return true
      } else {
        e.preventDefault()
        return false
      }
    },
  },
}
</script>

<style lang="scss">
.asc-derived-parameter-input {
  margin-top: 20px;

  .v-tab {
    max-width: initial;
  }
  .asc-input-field--container {
    flex: 3;
    margin-right: 20px;
  }
}

.labelFieldInput {
  display: flex;
  flex: 3;
  min-width: 350px;
}
</style>
